import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { organizationApi } from 'src/api/organization';
import { useSnackbar } from 'src/components/snackbar';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { translateKey } from 'src/locales/translate';


interface OrganizationDetailsFormDeleteModalProps {
  isUpdateLoading: boolean;
}

export default function OrganizationDetailsFormDeleteModal({
  isUpdateLoading,
}: OrganizationDetailsFormDeleteModalProps) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { organizationId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync: deleteOrganization, isLoading } = useMutation({
    mutationFn: (id: string) =>
      organizationApi.organizationControllerRemoveOrganization({
        id,
      }),
  });

  const handleDelete = async () => {
    try {
      await deleteOrganization(organizationId!);
      setIsOpen(false);
      navigate(PATH_DASHBOARD.general.organizations.root);
      enqueueSnackbar(translateKey("hardcoded.organizacja_zostala_usunieta"), {
        variant: 'success',
      });
    } catch (error) {
      enqueueSnackbar(error.message || error, {
        variant: 'error',
      });
    }
  };

  const closeModal = () => setIsOpen(false);

  const openModal = () => setIsOpen(true);

  return (
    <>
      <Button
        variant="contained"
        color="error"
        onClick={openModal}
        disabled={isUpdateLoading || isLoading}
      >{translateKey("common.remove")}</Button>
      <Dialog open={isOpen} onClose={closeModal}>
        <DialogTitle>{translateKey("hardcoded.probujesz_usunac_organizacje")}</DialogTitle>

        <DialogContent sx={{ maxWidth: '400px' }}>
          <DialogContentText id="alert-dialog-description">{translateKey("hardcoded.czy_na_pewno_chcesz_usunac_organizacje_ta_akcja")}</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={closeModal}>{translateKey("common.cancel")}</Button>
          <LoadingButton
            variant="contained"
            color="error"
            onClick={handleDelete}
            loading={isLoading}
          >
            <span>{translateKey("common.remove")}</span>
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
